module.exports = __webpack_public_path__ + "static/img/19070B_1_R_2020118_fit.64c8b41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19070B_1_R_2020118_fit.png
// module id = NKV1
// module chunks = 0